export interface AllTimeStatsProps {
  statistic: string | number
  subtitleText: string
}

export const AllTimeStat = ({ statistic, subtitleText }: AllTimeStatsProps) => {
  return (
    <div className='lg:w-1/2'>
      <p className='font-body-rebrand text-3xl font-bold text-tomThumb mb-0'>
        {statistic}
      </p>
      <p className='font-display-rebrand text-base font-normal uppercase text-tomThumb mt-2 mb-0'>
        {subtitleText}
      </p>
    </div>
  )
}
